"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _GeoClosestLocation = _interopRequireWildcard(require("../../darkmatter/GeoClosestLocation"));

var _Location = _interopRequireDefault(require("../../molecules/Location"));

require("./locations-filter.css");

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var LocationsFilter = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(LocationsFilter, _React$Component);

  var _super = _createSuper(LocationsFilter);

  function LocationsFilter(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, LocationsFilter);
    _this = _super.call(this, props);
    _this.state = {
      locations: props.locations,
      filterStr: '',
      startOrderByDistance: false
    };
    _this.applyFilter = _this.applyFilter.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderSortByDistanceLink = _this.renderSortByDistanceLink.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(LocationsFilter, [{
    key: "applyFilter",
    value: function applyFilter(locations) {
      var filterStr = this.state.filterStr;
      var filteredLocations = locations;

      if (filterStr && filterStr.length) {
        var re = new RegExp(filterStr, 'i');
        filteredLocations = locations.filter(function (loc) {
          var keys = Object.keys(loc);

          for (var i = 0; i < keys.length; i += 1) {
            var key = keys[i];

            if (key !== 'id' && (0, _typeof2["default"])(loc[key]) !== 'object' && re.test(loc[key])) {
              return true;
            }
          }

          return false;
        });
      }

      return filteredLocations;
    }
  }, {
    key: "renderSortByDistanceLink",
    value: function renderSortByDistanceLink(orderByDistanceStatus) {
      var _this2 = this;

      if (orderByDistanceStatus === _GeoClosestLocation.LOCATION_STATUS.IDLE) {
        return /*#__PURE__*/_react["default"].createElement("a", {
          href: "#",
          onClick: function onClick() {
            _this2.setState({
              startOrderByDistance: true
            });

            return false;
          }
        }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
          name: "location arrow"
        }), "Sort by distance");
      }

      if (orderByDistanceStatus === _GeoClosestLocation.LOCATION_STATUS.LOCATION_UNAVAILABLE) {
        return /*#__PURE__*/_react["default"].createElement("p", {
          className: "locations-filter-geostate-unavailable"
        }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
          name: "location arrow"
        }), "Location unavailable");
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          searchCta = _this$props.searchCta,
          placeholder = _this$props.placeholder,
          verticalAlign = _this$props.verticalAlign,
          horizonalAlign = _this$props.horizonalAlign,
          className = _this$props.className,
          showIcon = _this$props.showIcon,
          distanceUnit = _this$props.distanceUnit;
      var _this$state = this.state,
          filterStr = _this$state.filterStr,
          startOrderByDistance = _this$state.startOrderByDistance,
          locations = _this$state.locations;
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
        id: "location-grid",
        stackable: true,
        className: "component-section-container ".concat(className),
        verticalAlign: verticalAlign,
        textAlign: horizonalAlign
      }, /*#__PURE__*/_react["default"].createElement(_GeoClosestLocation["default"], {
        start: startOrderByDistance,
        locations: locations,
        distanceUnit: distanceUnit
      }, function (_ref) {
        var isLoading = _ref.isLoading,
            geoClosestLocations = _ref.locations,
            geoClosestLocationStatus = _ref.state;

        var filteredLocations = _this3.applyFilter(geoClosestLocations);

        var noResults = filteredLocations.length === 0;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
          width: 16
        }, /*#__PURE__*/_react["default"].createElement("h3", null, searchCta), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
          fluid: true,
          onChange: function onChange(e) {
            return _this3.setState({
              filterStr: e.target.value
            });
          },
          value: filterStr,
          action: isLoading ? {} : {
            icon: 'search'
          },
          placeholder: placeholder,
          loading: isLoading
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "locations-filter-geostate-label"
        }, _this3.renderSortByDistanceLink(geoClosestLocationStatus)))), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, null, noResults && /*#__PURE__*/_react["default"].createElement("p", {
          style: {
            color: 'gray'
          }
        }, "No results found with this criteria."), filteredLocations.map(function (loc) {
          return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
            id: loc.id,
            computer: 8,
            tablet: 8,
            mobile: 16,
            className: "location-filter-location-detail"
          }, /*#__PURE__*/_react["default"].createElement(_Location["default"], (0, _extends2["default"])({
            address: {
              street: loc.street,
              city: loc.city,
              state: loc.state,
              zip: loc.zip_code,
              country: loc.country
            },
            timezone: loc.timezone,
            hours: loc.hours,
            phone: loc.phone_number,
            header: loc.name,
            as: "card",
            showAddress: true,
            showIcon: showIcon,
            showMap: filteredLocations.length === 1
          }, loc)));
        })));
      }));
    }
  }]);
  return LocationsFilter;
}(_react["default"].Component);

exports["default"] = LocationsFilter;
LocationsFilter.propTypes = {
  searchCta: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  locations: _propTypes["default"].shape({
    location_name: _propTypes["default"].string,
    phone_number: _propTypes["default"].string,
    email: _propTypes["default"].string,
    phone: _propTypes["default"].string,
    hours: _propTypes["default"].array,
    street: _propTypes["default"].string,
    city: _propTypes["default"].string,
    state: _propTypes["default"].string,
    zip_code: _propTypes["default"].string,
    country: _propTypes["default"].string,
    link: _propTypes["default"].shape({
      url: _propTypes["default"].string,
      icon: _propTypes["default"].string,
      label: _propTypes["default"].string
    })
  }),
  verticalAlign: _propTypes["default"].string,
  horizonalAlign: _propTypes["default"].string,
  showIcon: _propTypes["default"].bool
};
LocationsFilter.defaultProps = {
  locations: [],
  searchCta: 'View our full list of locations below or search to find your favorite!',
  placeholder: 'Search',
  verticalAlign: 'center',
  horizonalAlign: 'center',
  showIcon: true
};